<template>
  <div class="checkbox">
    <label class="question" :for="randomId">{{ questionString }}</label>

    <label class="option" :for="`${randomId}-true`"
      >{{ getOptionText(option1Text, $mlGet("rmaTransport-default-option1")) }}
      <input type="checkbox" :id="`${randomId}-true`" v-model="radioValue" />
    </label>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class Checkbox extends Vue {
  public randomId = Math.random().toString(36);

  @Prop() public questionString!: string;
  @Prop() public option1Text?: string;
  @Prop() public option2Text?: string;
  @Prop({
    default: false
  })
  public confirmOnly?: boolean;

  mounted() {
    this.radioValue = this.value;
  }

  @Prop({ default: false })
  public value!: boolean;

  public radioValue = false;

  @Watch("value")
  public onValueChange() {
    this.radioValue = this.value;
  }

  @Watch("radioValue")
  @Emit("input")
  public onRadioValueChange() {
    return this.radioValue;
  }

  getOptionText(option: string | undefined, fallback: string): string {
    return option ? option : fallback;
  }
}
</script>

<style scoped>
.question {
  display: block;
}
</style>
